import React from 'react';

function NotFound() {
  return <div>Pagina no encontrada</div>;
}

export default NotFound;
